import { createTemplate } from '../../../../../helpers/template';

export default (mask, url) => {
  const slices = url.split('/').reverse();
  const folder = slices[0];
  return createTemplate(mask)({ folder });
};
